import { HttpErrorResponse } from '@angular/common/http';

import { EmailAi } from '@core/email-ai-types';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

const { actions, reducer, namespace, selectors } = createSingleEntityStore<EmailAi>()('EmailAi', {
  customActions: adapter => ({
    fetchRejectionEmails: (state, payload: { id: number; template?: string }) =>
      adapter.markAsPending(state),
    fetchRejectionEmailsSuccess: (state, payload: EmailAi) =>
      pipeState(
        state,
        next => adapter.save(next, payload),
        next => adapter.markAsLoaded(next),
      ),
    fetchRejectionEmailsFailed: (state, error: HttpErrorResponse) => adapter.setError(state, error),

    fetchCustomEmail: (state, payload: { id: number; message: string; template?: string }) =>
      adapter.markAsPending(state),
    fetchCustomEmailSuccess: (state, payload: EmailAi) =>
      pipeState(
        state,
        next => adapter.save(next, payload),
        next => adapter.markAsLoaded(next),
      ),
    fetchCustomEmailFailed: (state, error: HttpErrorResponse) => adapter.setError(state, error),

    fetchContinueEmail: (state, payload: { id: string; lastMessage: string; answer: string }) =>
      adapter.markAsPending(state),
    fetchContinueEmailSuccess: (state, payload: EmailAi) =>
      pipeState(
        state,
        next => adapter.save(next, payload),
        next => adapter.markAsLoaded(next),
      ),
    fetchContinueEmailFailed: (state, error: HttpErrorResponse) => adapter.setError(state, error),

    invalidateResponse: () => adapter.reset(),
  }),
});

const EmailAiActions = <
  Pick<
    typeof actions,
    | 'fetchRejectionEmails'
    | 'fetchRejectionEmailsSuccess'
    | 'fetchRejectionEmailsFailed'
    | 'fetchCustomEmail'
    | 'fetchCustomEmailSuccess'
    | 'fetchCustomEmailFailed'
    | 'fetchContinueEmail'
    | 'fetchContinueEmailSuccess'
    | 'fetchContinueEmailFailed'
    | 'invalidateResponse'
  >
>actions;

export {
  EmailAiActions,
  namespace as EmailAiNamespace,
  reducer as EmailAiReducer,
  selectors as EmailAiSelectors,
};
